const vehicles = {
  table: {
    headers: {
      supplier: 'ציים',
    },
    filters: {
      supplier: 'ציים',
    },
  },

  form: {
    information: {
      details: {
        fields: {
          suppliers: 'ציים',
        },
      },

      suppliers: {
        header: 'ציים',
        fields: {
          suppliers: 'ציים',
        },
      },
    },
  },
};

export default vehicles;
